<template>
  <div>
    <div class="page-header">
      <div>
        <div class="page-title">{{ isDetailMode ? '微信子商编详情' : '微信子商编申请' }}</div>
        <div class="page-subtitle">{{ isDetailMode ? '查看微信子商编详细信息' : '填写微信子商编申请信息' }}</div>
      </div>
      <el-button type="primary" plain @click="goBack">返回列表</el-button>
    </div>
    <el-card>
      <el-form label-width="160px">
        <el-form-item label="子商编类型" required>
          <el-radio-group v-model="form.subMerchantIdType">
            <el-radio label="0">扫码</el-radio>
            <el-radio label="1">跳转</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="商户属性" required>
          <el-input v-model="form.merchantAttribute" placeholder="固定为01特约商户" maxlength="2" show-word-limit disabled />
        </el-form-item>
        <el-form-item label="MCC 码" required>
          <el-select v-model="form.mcc" placeholder="请选择MCC码" style="width: 100%">
            <el-option v-for="item in mccList" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="渠道商编码" required>
          <el-input v-model="form.channelId" placeholder="请输入渠道商编码" maxlength="32" show-word-limit />
        </el-form-item>
        <el-form-item label="渠道商全称" required>
          <el-input v-model="form.channelFullName" placeholder="请输入渠道商全称" maxlength="50" show-word-limit />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm">{{ isDetailMode ? '修改信息' : '提交申请' }}</el-button>
          <el-button @click="goBack">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        subMerchantIdType: '0', // 默认跳转类型
        merchantAttribute: '01', // 固定为01特约商户
        mcc: '',
        channelId: '',
        channelFullName: ''
      },
      // MCC码列表
      mccList: [
        { label: '公共事业（电、气、水） (4900)', value: '4900' },
        { label: '商用计算机及服务器 (5045)', value: '5045' },
        { label: '计算机软件 (5734)', value: '5734' },
        { label: '软件系统商 (7372)', value: '7372' },
        { label: '信息检索服务 (7375)', value: '7375' },
        { label: '计算机维护和修理服务 (7379)', value: '7379' },
        { label: '其他娱乐服务 (7999)', value: '7999' }
      ],
      // 是否为详情模式
      isDetailMode: false,
      // 子商编id
      subMerchantId: ''
    };
  },
  computed: {},
  // 页面挂载完成
  mounted() {
    // 检查是否有id参数和subMerchantId参数
    this.checkForMerchantId();
  },
  methods: {
    // 检查URL参数中的商户id和子商编id
    checkForMerchantId() {
      const merchantId = this.$route.query.id;
      const subMerchantId = this.$route.query.subMerchantId;
      
      if (merchantId) {
        this.form.mid = merchantId;
        console.log('商户ID:', merchantId);
        
        if (subMerchantId) {
          // 进入详情模式
          this.isDetailMode = true;
          this.id = subMerchantId;
          console.log('子商编ID:', subMerchantId);
          // 加载子商编详情
          this.loadSubMerchantDetails(subMerchantId);
        }
      } else {
        this.$message.error('缺少商户ID参数');
      }
    },
    // 加载子商编详情
    loadSubMerchantDetails(subMerchantId) {
      this.$http_get(`/admin/merchant/subMerchantDetail?id=${subMerchantId}`, 1).then(res => {
        if (res && res.code === 200 && res.data) {
          // 填充表单数据
          this.form = { ...this.form, ...res.data };
          this.$message.success('加载详情成功');
        } else {
          this.$message.error(res.msg || '加载详情失败');
        }
      }).catch(err => {
        this.$message.error('网络错误');
        console.error('加载子商编详情失败:', err);
      });
    },
    // 提交表单
    submitForm() {
      // 基本信息验证
      if (!this.form.mid) {
        this.$message.warning("缺少商户ID");
        return;
      }
      if (!this.form.mcc) {
        this.$message.warning("请选择MCC码");
        return;
      }
      if (!this.form.channelId) {
        this.$message.warning("请输入渠道商编码");
        return;
      }
      if (!this.form.channelFullName) {
        this.$message.warning("请输入渠道商全称");
        return;
      }
      
      console.log('提交微信子商编申请:', this.form);
      this.$http_post("/admin/merchant/wechatSubMerchantApply", this.form, 1).then(res => {
        if (res && res.code === 200) {
          this.$message.success('提交成功');
          // this.goBack();
        } else {
          this.$message.error(res.msg || '提交失败');
        }
      }).catch(err => {
        this.$message.error('网络错误');
        console.error('提交微信子商编申请失败:', err);
      });
    },
    // 返回列表
    goBack() {
       history.back();
    }
  }
};
</script>